import { jsxs as t, jsx as r } from "react/jsx-runtime";
const s = ({ size: a = 24, ...n }) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 32 32",
    fill: "none",
    ...n,
    children: [
      /* @__PURE__ */ t("g", { children: [
        /* @__PURE__ */ r(
          "path",
          {
            d: "m-7.678 0h60.8v2.462h-60.8zm0 4.925h60.8v2.462h-60.8zm0 4.919h60.8v2.469h-60.8zm0 4.925h60.8v2.462h-60.8zm0 4.925h60.8v2.462h-60.8zm0 4.919h60.8v2.462h-60.8zm0 4.925h60.8v2.462h-60.8z",
            fill: "#bd3d44"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            d: "m-7.678 2.462h60.8v2.462h-60.8zm0 4.925h60.8v2.456h-60.8zm0 4.919h60.8v2.462h-60.8zm0 4.925h60.8v2.462h-60.8zm0 4.925h60.8v2.462h-60.8zm0 4.919h60.8v2.462h-60.8z",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ r("path", { d: "m-7.678 0h24.32v17.23h-24.32z", fill: "#192f5d" })
      ] }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "path380",
          d: "m-9.062 0 0.2188 0.6812h0.7187l-0.5812 0.4187 0.225 0.6875-0.5813-0.425-0.5812 0.4188 0.225-0.6812-0.5813-0.4187h0.7188z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t("g", { id: "g396", children: [
        /* @__PURE__ */ r("use", { transform: "translate(21.65 2.462)", xlinkHref: "#path380" }),
        /* @__PURE__ */ r("use", { transform: "translate(17.6 2.462)", xlinkHref: "#path380" }),
        /* @__PURE__ */ r("use", { transform: "translate(13.55 2.462)", xlinkHref: "#path380" }),
        /* @__PURE__ */ r("use", { transform: "translate(9.494 2.462)", xlinkHref: "#path380" }),
        /* @__PURE__ */ r("use", { transform: "translate(5.441 2.462)", xlinkHref: "#path380" })
      ] }),
      /* @__PURE__ */ t("g", { id: "g395", children: [
        /* @__PURE__ */ r("use", { transform: "translate(19.63 .7373)", xlinkHref: "#path380" }),
        /* @__PURE__ */ r("use", { transform: "translate(15.57 .7373)", xlinkHref: "#path380" }),
        /* @__PURE__ */ r("use", { transform: "translate(11.52 .7373)", xlinkHref: "#path380" }),
        /* @__PURE__ */ r("use", { transform: "translate(7.466 .7373)", xlinkHref: "#path380" }),
        /* @__PURE__ */ r("use", { transform: "translate(3.413 .7373)", xlinkHref: "#path380" }),
        /* @__PURE__ */ r("use", { transform: "translate(23.68 .7373)", xlinkHref: "#path380" })
      ] }),
      /* @__PURE__ */ r("use", { transform: "translate(0,3.45)", xlinkHref: "#g395" }),
      /* @__PURE__ */ r("use", { transform: "translate(-.0031 6.891)", xlinkHref: "#g395" }),
      /* @__PURE__ */ r("use", { transform: "translate(2.5e-5 10.33)", xlinkHref: "#g395" }),
      /* @__PURE__ */ r("use", { transform: "translate(0 13.79)", xlinkHref: "#g395" }),
      /* @__PURE__ */ r("use", { transform: "translate(0 3.444)", xlinkHref: "#g396" }),
      /* @__PURE__ */ r("use", { transform: "translate(0 6.894)", xlinkHref: "#g396" }),
      /* @__PURE__ */ r("use", { transform: "translate(0 10.34)", xlinkHref: "#g396" }),
      "=",
      " "
    ]
  }
);
export {
  s as RegionUSAIcon
};
